import Vue from 'vue';
import InstantSearch from 'vue-instantsearch';
import 'vue-googlemaps/dist/vue-googlemaps.css';
import VueGoogleMaps from 'vue-googlemaps';

if (document.querySelector('#destinations-page')) {

    Vue.use(InstantSearch);
    Vue.component('destinations-search', require('@/components/Destinations/Search').default);

    window.suggestSpot = new Vue({
        name: 'Destinations Page',
        el: '#destinations-page',
    });
}

if (document.querySelector('#destination-map-search-page')) {

    Vue.use(InstantSearch);
    Vue.use(VueGoogleMaps, {
        load: {
            apiKey: process.env.MIX_MAPS_API_KEY,
            // useBetaRenderer: true,
            libraries: ['places'],
            useBetaRenderer: false,
        },
    });
    Vue.component('destination-map-search', require('@/components/Destinations/Browse/Index').default);

    window.destinationMapSearch = new Vue({
        name: 'Destination Map Search Page',
        el: '#destination-map-search-page',
    });
}
